import { render, staticRenderFns } from "./receipt_ec.vue?vue&type=template&id=6b09ef68&scoped=true&"
import script from "./receipt_ec.vue?vue&type=script&lang=js&"
export * from "./receipt_ec.vue?vue&type=script&lang=js&"
import style0 from "./receipt_ec.vue?vue&type=style&index=0&id=6b09ef68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b09ef68",
  null
  
)

component.options.__file = "receipt_ec.vue"
export default component.exports